import { Vue, newVue } from '@/config/vue'

On.VueInit({
  controller: 'products',
  init() {
    const LockedModal = Vue.component('locked-modal', () =>
      import(/* webpackChunkName: "locked-modal" */ './LockedModal.vue')
    )
    newVue({
      render: h => h(LockedModal),
      mount: '.js-vue-locked-modal',
    })
  },
})
